import {
  Autocomplete,
  Box,
  Button,
  Card,
  Container,
  Flex,
  Image,
  Loader,
  Select,
  SimpleGrid,
  TextInput,
  createStyles,
  rem,
} from "@mantine/core";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import { updateBusinessProfile } from "../../../../services/profile";
import { uploadFileToS3Api } from "../../../../utils/PresignedUrlFunction";
import { showError } from "../../../../utils";
import { PhoneInput } from "react-international-phone";
import { useNavigate } from "react-router-dom";
import {
  countries,
  debounce,
  extractAddressFieldsFromGoogleRes,
  getAllTimezonesWithAbbr,
  isIncompleteAddressDetails,
} from "../../../../utils";
import { stateZipCodes } from "../../../../utils/zipCodes";
import { useEffect, useRef, useState } from "react";
import {
  getAddressByPlaceId,
  searchAddress,
} from "../../../../services/dashboard";
import swal from "sweetalert";
import { useCallback } from "react";
import { IconBuilding, IconCamera, IconChevronDown } from "@tabler/icons-react";

const useStyles = createStyles((theme) => ({
  wrapper: {
    marginBottom: 40,
    backgroundColor: "#FFF",
    padding: "41px 14px 0 14px",
  },
  hdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    marginBottom: 15,
  },

  camera: {
    position: "absolute",
    marginTop: 75,
    marginLeft: 75,
    background: "#FFBA45",
    borderRadius: "50%",
    padding: 5,
    [`&:hover`]: {
      cursor: "pointer",
    },
  },
  box: {
    width: 280,
    paddingTop: 47,
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderRightColor: "#F2F2F2",
    textAlign: "center",
  },
  inputIcon: {
    borderRightWidth: 1,
    borderRigthColor: "#CBCBCB",
    borderRightStyle: "solid",
    paddingRight: 5,
  },
  changepwd: {
    position: "absolute",
    color: "#FFBA45",
    fontFamily: "Inter",
    fontSize: rem(14),
    marginLeft: "auto",
    textDecoration: "underline",
    paddingBottom: 10,
    marginTop: 9,
  },
  cancelBtn: {
    padding: "0px 20px",
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    backgroundColor: "#F5F5F5",
    height: 60,
    flex: 1,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  submitBtn: {
    padding: "0px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    flex: 1,
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    maxWidth: 857,
    width: "100%",
    margin: "0 auto",
  },
  label: {
    width: "100%",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#344054",
    margin: 0,
    marginBottom: 10,
  },
  phoneInput: {
    "& button": {
      height: "48px",
      borderColor: "#CBD5E1 !important",
      borderTopLeftRadius: "8px !important",
      borderBottomLeftRadius: "8px !important",
    },
    "& .react-international-phone-input": {
      height: "48px !important",
      borderColor: "#CBD5E1 !important",
      width: "100%",
      borderTopRightRadius: "8px !important",
      borderBottomRightRadius: "8px !important",
    },
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      marginBottom: 8,
    },
    "& .mantine-Input-wrapper": {
      height: 48,
      borderRadius: 8,
      border: "1px solid #CBD5E1",
      background: "transparent",
      transition: "border-color 0.2s ease",

      "& .mantine-Select-rightSection svg": {
        color: "#94A3B8",
      },

      "& input": {
        height: "100%",
        border: "none",
        borderRadius: 8,
        padding: "0px 12px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },

        "&:focus": {
          outline: "none",
        },
      },
    },

    "& .mantine-Select-wrapper": {
      padding: 0,
      "& .mantine-Select-input": {
        paddingLeft: 12,
        paddingRight: 36,
        height: 48,
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },
      },
    },
  },

  btnsRow: {
    gap: 12,
    borderTop: "1px solid #E5E5E5",
    marginTop: 64,
    padding: "18px 20px",
  },
}));
const BusinessProfile = ({ currentTab }) => {
  const { profile, saveProfileLoading } = useSelector(
    (state) => state?.profile,
  );
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [userAddressFromGoogleApi, setUserAddressFromGoogleApi] =
    useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [addressSuggestionsLoading, setAddressSuggestionsLoading] =
    useState(false);

  // Business logo — uploaded/stored exactly like the user profile photo.
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedLogoLoading, setSelectedLogoLoading] = useState(false);
  const logoRef = useRef();

  const handleLogoChange = async (files) => {
    if (!files?.length) return;
    const file = files[0];
    try {
      setSelectedLogoLoading(true);
      const result = await uploadFileToS3Api({ file });
      setSelectedLogo(result);
    } catch (error) {
      showError(error?.message || "Upload failed");
    } finally {
      setSelectedLogoLoading(false);
    }
  };

  const form = useForm({
    initialValues: {
      businessEmail: profile?.business?.businessEmail,
      companyName: profile?.business?.companyName,
      contactPhone: profile?.business?.contactPhone,
      industry: profile?.business?.industry,
      // line1: profile?.business?.line1,
      // state: profile?.business?.state,
      // city: profile?.business?.city,
      // postal_code: profile?.business?.postal_code,
      // timezone: profile?.business?.timezone,
    },
    validate: {
      companyName: (value) => (value ? null : "Required"),
      businessEmail: (value) =>
        /^\S+@\S+$/.test(value) ? null : "Invalid email",
      contactPhone: (value) => (value ? null : "Required"),
      industry: (value) => (value ? null : "Required"),
      // line1: (value) => (value?.trim() ? null : "Required"),
      // state: (value) => (value?.trim() ? null : "Required"),
      // city: (value) => (value?.trim() ? null : "Required"),
      // postal_code: (value) => (value?.trim() ? null : "Required"),
      // timezone: (value) => (value ? null : "Required"),
    },
  });
  const onFinish = async (values) => {
    const payload = {
      ...values,
      country: userAddressFromGoogleApi?.country || "US",
      logo: selectedLogo?.uploadURL || profile?.business?.logo || "",
    };
    await updateBusinessProfile(payload);
    navigate("/home/dashboard");
  };

  const handleSearchAddress = async (value) => {
    try {
      const data = await searchAddress(value);
      const options = data?.map((item) => ({
        value: item.place_id,
        label: item.formatted_address,
      }));
      setAddressSuggestions(() => options || []);
    } catch (error) {
    } finally {
      setAddressSuggestionsLoading(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      handleSearchAddress(value);
    }, 1000),
    [],
  );

  const addressOnChange = (value) => {
    form.setFieldValue("line1", value);
    if (value?.trim()) {
      setAddressSuggestionsLoading(true);
      debouncedSearch(value);
    } else {
      setAddressSuggestions([]);
      setAddressSuggestionsLoading(false);
    }
  };

  const handleGetAddressDetails = async (item) => {
    try {
      form.setFieldValue("line1", item.label);
      const response = await getAddressByPlaceId(item.value);
      const addressDetail = extractAddressFieldsFromGoogleRes(response);
      setUserAddressFromGoogleApi(addressDetail);
      form.setValues(addressDetail);
    } catch (error) {}
  };

  return (
    <>
      <form onSubmit={form?.onSubmit((values) => onFinish(values))}>
        <p className={classes.hdng}>Data informations</p>
        <Box className={classes.wrapper}>
          <Box className={classes.inputContainer}>
            <div className={classes.inputField}>
              <p className={classes.label} style={{ marginBottom: 8 }}>Business logo</p>
              <Flex align="center" gap={16}>
                <div style={{ position: "relative", width: 64, height: 64, flexShrink: 0 }}>
                  <Dropzone
                    onDrop={(files) => handleLogoChange(files)}
                    openRef={logoRef}
                    accept={MIME_TYPES.jpeg | MIME_TYPES.png}
                    style={{ position: "absolute", width: 0, height: 0, padding: 0, border: 0, overflow: "hidden" }}
                  />
                  {selectedLogoLoading && !selectedLogo ? (
                    <Flex h={64} w={64} align="center" justify="center" style={{ borderRadius: 12, border: "1px solid #e5e5e5" }}>
                      <Loader color="#FFBA45" size="sm" />
                    </Flex>
                  ) : selectedLogo?.uploadURL || profile?.business?.logo ? (
                    <Image
                      src={selectedLogo?.uploadURL || profile?.business?.logo}
                      alt="Business logo"
                      width={64}
                      height={64}
                      radius={12}
                      onClick={() => logoRef.current?.()}
                      styles={{ image: { objectFit: "cover", border: "1px solid #e5e5e5", borderRadius: 12 } }}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <Flex
                      h={64}
                      w={64}
                      align="center"
                      justify="center"
                      onClick={() => logoRef.current?.()}
                      style={{ borderRadius: 12, border: "1px solid #e5e5e5", background: "#f4f4f5", cursor: "pointer" }}
                    >
                      <IconBuilding size={28} color="#98a2b3" />
                    </Flex>
                  )}
                </div>
                <div>
                  <Button variant="default" size="xs" leftIcon={<IconCamera size={15} />} onClick={() => logoRef.current?.()}>
                    {selectedLogo?.uploadURL || profile?.business?.logo ? "Change logo" : "Upload logo"}
                  </Button>
                  <p style={{ margin: "6px 0 0", fontSize: 12, color: "#98a2b3" }}>JPG or PNG</p>
                </div>
              </Flex>
            </div>
            <TextInput
              label={"Company Name"}
              className={classes.inputField}
              {...form.getInputProps("companyName")}
            />
            <TextInput
              label={"Email"}
              className={classes.inputField}
              {...form.getInputProps("businessEmail")}
              disabled
            />
            {/* <TextInput
                label={"Phone number"}
                size="md"
                type="number"
                icon={
                  <img
                    src={"/assets/images/sms.png"}
                    alt=""
                    className={classes.inputIcon}
                  />
                }
                {...form.getInputProps("contactPhone")}
              /> */}
            <div className={classes.phoneInputBox}>
              <p className={classes.label}>Phone number</p>
              <PhoneInput
                defaultCountry="us"
                // value={phone}
                // onChange={(phone) => setPhone(phone)}
                {...form.getInputProps("contactPhone")}
                className={classes.phoneInput}

                // disabled={view}
              />
            </div>
            <Select
              label={"Industry"}
              searchable
              className={classes.inputField}
              rightSection={<IconChevronDown size={20} />}
              rightSectionWidth={30}
              {...form.getInputProps("industry", { type: "select" })}
              data={[
                {
                  value: "health care",
                  label: "Health Care",
                },
                { value: "transportation", label: "Transportation" },
              ]}
            />
            {/* <Autocomplete
                label={"Address"}
                size="md"
                data={addressSuggestions}
                value={form.values.line1}
                onChange={addressOnChange}
                maxDropdownHeight={200}
                filter={() => true}
                limit={Infinity}
                withAsterisk
                rightSection={addressSuggestionsLoading ? <Loader size="xs" color="yellow" /> : null}
                onItemSubmit={handleGetAddressDetails}
                error={form?.errors?.line1}
              />
              <TextInput
                label="State"
                size="md"
                withAsterisk
                {...form.getInputProps("state")}
              />
              <TextInput
                label={"City"}
                size="md"
                withAsterisk
                {...form.getInputProps("city")}
              />
              <TextInput
                label="Zipcode"
                withAsterisk
                size="md"
                {...form.getInputProps("postal_code")}
              /> */}

            {/* <Select
                label="Business Timezone"
                id="timezone"
                searchable
                size="md"
                placeholder="Select Business Timezone"
                data={getAllTimezonesWithAbbr()}
                {...form.getInputProps("timezone")}
              /> */}
          </Box>
          <Flex className={classes.btnsRow}>
            <Button
              variant="outline"
              className={classes.cancelBtn}
              onClick={() => navigate("/home/dashboard")}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className={classes.submitBtn}
              loading={saveProfileLoading}
            >
              Save
            </Button>
          </Flex>
        </Box>
      </form>
    </>
  );
};

export default BusinessProfile;
